<template>
<b-modal id="modalReadCode" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
	<div class="fullscreen" v-if="show">
		<div class="code-reader transition">
			<div class="btn " @click="closeScan()" v-if="opened"><i class="icon icon-close invert"></i></div>
			<div class="layer transition" v-if="opened"></div>
			<qrcode-stream @decode="onDecode" @init="onInit" ref="rootElement"></qrcode-stream>
		</div>

	</div>
</b-modal>

</template>

<script>
import gql from 'graphql-tag'
import { QrcodeStream } from 'vue-qrcode-reader'
import Loader from '@/components/Loader'

export default {
	name: 'readCode',
	components:{
		Loader,
		QrcodeStream,
	},
	props:['title'],
	data () {
		return {
			loading: false,
			show: false,
			opened :false,
			touched :false,
			showReader: false,
			showSearch: false,
			cars:[],
			searchTerms:null,
			beep: new Audio(require('@/assets/beep.mp3')),
			loadCarById: null,
			settings: {}
		}
	},
	
	methods:{
		
		open() {
			this.show = true
			this.openScan()
			this.$bvModal.show('modalReadCode')
		},
		close () {
			this.loadCarById = null
			this.searchTerms = null
			this.showReader = false
			this.showSearch = false
			this.$bvModal.hide('modalReadCode')
		},
		openScan(){
			this.showReader = true
		},
		closeScan(){
			this.close()
			this.showReader = false
			this.opened = false
		},
		
		async  onInit(promise){
			try{
				await promise
				this.opened = true
			} catch(error){
				console.log(error)
			}
		},
		onDecode(data){
			this.beep.play()
			data =  JSON.parse(data)
			if(data.chassis_number){
				this.$emit('readed', data.chassis_number)
			}
			this.closeScan()
		},
		
		
	}
}


</script>

<style scoped lang="scss">
.code-reader{
	width:100%;
	height:100%;
	z-index:100;
	top:0px;
	position:fixed;

	.btn{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 11;
		font-size:18px;
		color:	#fff;
	}
}
.layer{
	position:absolute;
	top:0;
	width:100%;
	height:100%;
	background:rgba(155,155,155,0.6) ;	
	z-index: 10;
	-webkit-clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
	clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
}
</style>
